const customUUID4Generator = () => {
    const toEvaluateNumber = ([ 1e7 ] + -1e3 + -4e3 + -8e3 + -1e11);
    const randomValue = crypto.getRandomValues(new Uint8Array(1))[0];
    return toEvaluateNumber.replace(/[018]/g, c => (
        // eslint-disable-next-line no-bitwise
        (c ^ randomValue) & (15 >> c) / 4
    ).toString(16));
};

const generateUUID4 = () => ((typeof window.crypto?.randomUUID === 'function') && window.crypto.randomUUID()) || customUUID4Generator();

export default generateUUID4;
